import { css } from 'aphrodite';
import { FC } from 'react';
import { bs } from '../../../web/styles/styles';
import { styleSheet } from './styles';

export const Divider: FC = () => {
	return <div className={css(bs.flex, bs.wFull, styleSheet.borderBottom)} />;
};
